import script from "./ClientPortalRepository.vue?vue&type=script&lang=js"
export * from "./ClientPortalRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__